
import { mapState } from 'vuex';
import { stateAwareRouteDefinition, applyStatetoRoute } from '@/support';
import { STICK_SETTING } from '@/store/mutation-types';

export default {
  computed: {
    ...mapState(['sidebar', 'lights']),
  },

  methods: {
    toggleLights() {
      this.toggle('lights');
    },

    toggleSidebar() {
      this.toggle('sidebar');
    },

    toggle(what) {
      const state = {
        [what]: !this[what],
      };
      const route = applyStatetoRoute(stateAwareRouteDefinition(), state);

      this.$store.commit(STICK_SETTING, { setting: what });
      this.$router.push(route);
    },
  },
};
